import React, { useEffect, useState } from 'react';
import { ErrorMessage } from '@hookform/error-message';
import { useForm, Controller } from 'react-hook-form';
import { Row, Form, Col, Input } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { ScreenPrompt } from '../../../../../components/ScreenPrompt';

import ReactButton from '../../../../../components/Buttons/ReactButton';
import WhatsappBlockListService from '../../../services';
import { FlexController } from 'components/FlexControllerInput';

const ActiveWhatsappBlockInputs = ({ blockedNumber }) => {
  const history = useHistory();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { control, handleSubmit, errors, reset, formState, setValue, watch } =
    useForm();

  const { isDirty } = formState;

  useEffect(() => {
    if (blockedNumber) {
      reset({
        phone: {
          ddi: blockedNumber.ddi,
          number: blockedNumber.telephone
        },
        reason: blockedNumber.reason || ''
      });
    }
  }, [blockedNumber, reset]);

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    const userLogin = localStorage.getItem('login');
    data.userLogin = userLogin;

    const formattedData = {
      ddi: data.phone?.ddi || data.phone_ddi,
      telephone: data.phone?.number || data.phone_number,
      reason: data.reason,
      userLogin: userLogin
    };

    try {
      if (blockedNumber) {
        await WhatsappBlockListService.update(blockedNumber.id, formattedData);
        toast.success('Número bloqueado atualizado com sucesso');
      } else {
        await WhatsappBlockListService.create(formattedData);
        toast.success('Número bloqueado com sucesso');
      }
      history.push('/admin/chat/active-whatsapp-block-list');
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || 'Erro ao salvar número bloqueado';
      toast.error(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    history.push('/admin/chat/active-whatsapp-block-list');
  };

  return (
    <>
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <Row className="mb-3">
          <Col sm="6">
            <FlexController
              type="phone"
              label="Telefone"
              name="phone"
              disabled={false}
              showMessageButton={false}
              showCallButton={false}
              watch={watch}
              value={watch('phone')}
              control={control}
              errors={errors}
              rules={{ required: 'Campo obrigatório' }}
              valueController={(fieldName, value) => {
                setValue(fieldName, value);
              }}
            />

            <ErrorMessage
              errors={errors}
              name="name"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
          <Col sm="6">
            <label className="form-control-label">Motivo do bloqueio*</label>
            <Controller
              as={<Input type="textarea" name="reason" />}
              control={control}
              rules={{ required: 'Campo obrigatório' }}
              name="reason"
              defaultValue=""
            />
            <ErrorMessage
              errors={errors}
              name="reason"
              render={({ message }) => errorFormMessage(message)}
            />
          </Col>
        </Row>

        <ReactButton
          btnColor="confirmation"
          type="submit"
          disabled={isSubmitting}
          isLoading={isSubmitting}
        >
          Salvar
        </ReactButton>

        <ReactButton
          btnColor="cancelation"
          onClick={() => {
            return cancelAction();
          }}
        >
          Cancelar
        </ReactButton>
      </Form>
    </>
  );
};

export default ActiveWhatsappBlockInputs;
